// extracted by mini-css-extract-plugin
export default {"container":"styles_container__86GWB","main":"styles_main__cJmNP","content":"styles_content__vIp41","title":"styles_title__h2CzI"};